// @flow
import * as React from 'react';

import { getLocale } from '../i18n';
import settings from '../settings';
import Link from '../link';
import TermsAndConditionsModal from '../../application/components/terms-and-conditions-modal';

import t from './locale';
import cs from './styles.pcss';

const now = new Date();

export default function Footer(): React.Node {
  const [showTermsModal, setShowTermsModal] = React.useState(false);
  const [userTermsStatus, setUserTermsStatus] = React.useState(null);

  const getCSRFToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
  };

  // 预先加载用户状态
  React.useEffect(() => {
    const loadUserStatus = async () => {
      try {
        const response = await fetch('/terms_and_conditions/content', {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': getCSRFToken(),
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin'
        });

        if (response.ok) {
          const termsData = await response.json();
          console.log('T&C Landing Footer: Loaded user status:', termsData);
          setUserTermsStatus(termsData);
        } else {
          console.error('T&C Landing Footer: Failed to load user status');
          setUserTermsStatus({ is_jp_kr_user: false, has_accepted_terms: false });
        }
      } catch (error) {
        console.error('T&C Landing Footer: Error loading user status:', error);
        setUserTermsStatus({ is_jp_kr_user: false, has_accepted_terms: false });
      }
    };

    loadUserStatus();
  }, []);

  const handleTermsClick = (e) => {
    console.log('T&C Landing Footer: Terms link clicked');
    console.log('T&C Landing Footer: Current user status:', userTermsStatus);

    // 检查是否有用户状态数据
    if (userTermsStatus) {
      const shouldShowModal = userTermsStatus.is_jp_kr_user && userTermsStatus.has_accepted_terms;
      console.log('T&C Landing Footer: shouldShowModal:', shouldShowModal);

      if (shouldShowModal) {
        // JP/KR用户且已接受条款 -> 显示弹框
        e.preventDefault();
        console.log('T&C Landing Footer: Preventing default and showing modal');
        setShowTermsModal(true);
      } else {
        // 其他情况 -> 允许默认跳转
        console.log('T&C Landing Footer: Allowing default link behavior');
      }
    } else {
      // 用户状态未加载，允许默认跳转
      console.log('T&C Landing Footer: User status not loaded, allowing default behavior');
    }
  };

  const handleCloseModal = () => {
    setShowTermsModal(false);
  };

  return (
    <>
    <ul className={cs.footer}>
      <li className={cs.item}>
        <Link
          className={cs.link}
          href={settings.helpCenter(getLocale())}
          area="footer"
        >
          {t('helpCenter')}
        </Link>
      </li>
      <li className={cs.item}>
        <Link
          className={cs.link}
          href={settings.faq(getLocale())}
          area="footer"
        >
          {t('faq')}
        </Link>
      </li>
      <li className={cs.item}>
        <Link
          className={cs.link}
          href="/articles/terms"
          area="footer"
          onClick={handleTermsClick}
        >
          {t('terms')}
        </Link>
      </li>
      <li className={cs.item}>{t('copyright', { year: now.getFullYear() })}</li>
      <li className={cs.item}>{t('message')}</li>
    </ul>

    {/* Terms & Conditions Modal for JP/KR users who have already accepted */}
    <TermsAndConditionsModal
      isOpen={showTermsModal}
      onAccept={handleCloseModal}
      showCloseButton={true}
      onClose={handleCloseModal}
      viewMode={true}
    />
  </>);
}
